// extracted by mini-css-extract-plugin
module.exports = {"button":"sign-button_button__3uwFQ"};